import { render, staticRenderFns } from "./FastCode.vue?vue&type=template&id=3762fefc&"
import script from "./FastCode.vue?vue&type=script&lang=js&"
export * from "./FastCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports